/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Project_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to import team project. {message}" |
*
* @param {Team_Project_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_failed = /** @type {((inputs: Team_Project_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’importation du projet d’équipe. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Teamprojekt konnte nicht importiert werden. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare il progetto del team. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать командный проект. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar el proyecto del equipo. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`团队项目导入失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`チームプロジェクトのインポートに失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट आयात करने में विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar o projeto da equipe. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to import team project. ${i?.message}`)
});